// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { AccessibilityAuxService } from '@client/app/pages/accessibility/services/accessibility-aux/accessibility-aux.service';
import { Domain } from '@monsido/ng2/modules/models/api/domain';

/**
 * Angular pipe that checks if domain uses selected guideline
 * Converted from AngularJS filter 'accessibilityHasGuideline'
 */
@Pipe({
    name: 'accessibilityHasGuideline',
    standalone: false,
})
export class AccessibilityHasGuidelinePipe implements PipeTransform {
    constructor (private accessibilityAuxService: AccessibilityAuxService) {}

    /**
     * Check if domain uses selected guideline
     * @param guideline - The guideline to check
     * @param domain - Selected domain (optional)
     * @returns Boolean indicating if domain uses the guideline
     */
    transform (guideline: string, domain?: Domain): boolean {
        return this.accessibilityAuxService.hasGuideline(guideline, domain);
    }
}
